import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'ink' | 'cream';
  level?: 2 | 3;
}
export function SectionHeading({
  eyebrow,
  title,
  intro,
  align = 'center',
  tone = 'ink',
  level = 2
}: SectionHeadingProps) {
  const Tag = level === 2 ? 'h2' : 'h3';
  const alignment = align === 'center' ? 'items-center text-center mx-auto' : 'items-start text-left';
  const titleColor = tone === 'ink' ? 'text-ink' : 'text-cream';
  const introColor = tone === 'ink' ? 'text-muted' : 'text-cream/70';
  const eyebrowColor = tone === 'ink' ? 'text-coral' : 'text-coral';
  return <div className={`flex max-w-reading flex-col gap-5 ${alignment}`} data-id="element-188" data-mp="1spq9it1e7hu">
      {eyebrow ? <span className={`text-xs font-semibold uppercase tracking-[0.22em] ${eyebrowColor}`} data-id="element-189" data-mp="6rkamp6nk442">{eyebrow}</span> : null}
      <Tag className={`font-display text-3xl leading-[1.08] sm:text-4xl lg:text-[2.9rem] ${titleColor}`} data-id="element-190" data-mp="z9xz3y63mdqh">
        {title}
      </Tag>
      {intro ? <p className={`text-lg leading-relaxed ${introColor}`} data-id="element-191" data-mp="1tb0kirrzqhez">{intro}</p> : null}
    </div>;
}